<template>
  <div class="cd_hero">
    <video poster="https://assets.creekdog.org/kayak-deckers.jpg" loop ref="video">
      <source src="https://assets.creekdog.org/kayak-deckers.mp4" type="video/mp4">
    </video>
    <div class="cd_hero--call-to-action" ref="callToAction">
      <h1 class="pb-3">Be a Watershed Watchdog</h1>
      <p>CreekDog is an easy-to-use reporting tool that aims to improve the quality of the Deckers Creek watershed.</p>
    </div>
    <div class="play-pause">
      <button class="btn btn-sm btn-info" @click="play()">
        <font-awesome-icon :icon="playPause" :aria-labelledby="playPauseAria" ref="playPauseIcon" />
        <span class="sr-only">Play</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Hero',
    data () {
      return {
        playPause: "play",
        playPauseAria: "Play"
      }
    },
    methods: {
      play: function () {
        if (this.$refs.video.currentTime > 0 && !this.$refs.video.paused && !this.$refs.video.ended && this.$refs.video.readyState > 2){
          this.$refs.video.pause()
          this.playPause = "play"
          this.playPauseAria = "Play"
          this.$refs.callToAction.classList.remove('fade')
        } else {
          this.$refs.callToAction.classList.add('fade')
          this.$refs.video.play()
          this.playPause = "pause"
          this.playPauseAria = "Pause"
        }
      }
    }
  }
</script>
